<template>
  <div class="tut-taget-item">
    <p>{{ t('label_my_language') }}</p>
    <div class="sample lang-grd-mic">
      <h4>{{ t('language_meta') }}</h4>
      <IconArrow />
    </div>
  </div>
</template>
<script setup lang="ts">
import IconArrow from '@/components/icons/IconArrow.vue';

const { t } = useI18n();
</script>
<style scoped lang="scss">
.tut-taget-item {
  background: var(--surface-overlay);
  border: 2px solid $color-navy-50;
  border-radius: $size-s;
  width: auto;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  gap: $size-m;
  text-align: center;
  white-space: nowrap;

  .lang-grd-mic {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: $size-xs;
    h4 {
      background: var(--font-gradient-language);
      -webkit-text-fill-color: transparent;
      background-clip: text;
      -webkit-background-clip: text;
      font-size: $font-size-h6;
      font-weight: 600;
      white-space: nowrap;
    }
    svg {
      transform: rotate(180deg);
      color: var(--font-default);
    }
  }
}

@include respond-to(tablet) {
  .tutorial-pop {
    .tutorial-con {
      width: calc(100% - 72px);
    }
  }
}

@include respond-to(mobile-landscape) {
  .tutorial-pop {
    .tutorial-con {
      width: 100%;
    }
  }
}
</style>
